import React, { useState } from 'react';
import { validateFunctionalForm } from '../../utils';
import constant from '../../constant';

const ResetPassword = (props) => {
    const { message } = props;
    const [state, setState] = useState({
        password: { name: 'password', value: '', isRequired: true, error: '' },
        confirm_password: { name: 'confirm_password', value: '', isRequired: true, error: '' },
    });

    const onChange = (e) => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: {
                ...prevState[name],
                value: value,
                error: prevState[name].isRequired && !value ? 'This field is required' : ''
            }
        }));
    };

    const onSubmit = (e) => {
        e.preventDefault();
        let isValid = validateFunctionalForm(state, setState);

        // Additional check: password and confirm_password match
        if (state.password.value !== state.confirm_password.value) {
            setState(prev => ({
                ...prev,
                confirm_password: {
                    ...prev.confirm_password,
                    error: 'Passwords do not match',
                }
            }));
            isValid = false;
        }

        if (isValid) {
            const model = {
                password: state.password.value
            };
            props.onSubmit(model);
        }
    };

    return (
        <React.Fragment>
            <>
                <div
                    className="alert alert-success text-center mb-4"
                    role="alert"
                    style={{ whiteSpace: 'nowrap' }}
                >
                    {message ? message : 'Enter your new password to reset your account.'}
                </div>

                {message && (
                    <div className="text-center mb-4">
                        <a href="/login" className="text-primary fw-bold">
                            Click here to login
                        </a>
                    </div>
                )}
            </>



            {!message && (
                <form className="form-horizontal" onSubmit={onSubmit}>

                    <div className="mb-3">
                        <label className="form-label">New Password</label>
                        <input
                            type="password"
                            className={state.password.error ? "form-control is-invalid" : "form-control"}
                            name={state.password.name}
                            value={state.password.value}
                            onChange={onChange}
                            placeholder="Enter new password"
                        />
                        {state.password.error && (
                            <div className="invalid-feedback">{state.password.error}</div>
                        )}
                    </div>

                    <div className="mb-3">
                        <label className="form-label">Confirm Password</label>
                        <input
                            type="password"
                            className={state.confirm_password.error ? "form-control is-invalid" : "form-control"}
                            name={state.confirm_password.name}
                            value={state.confirm_password.value}
                            onChange={onChange}
                            placeholder="Confirm new password"
                        />
                        {state.confirm_password.error && (
                            <div className="invalid-feedback">{state.confirm_password.error}</div>
                        )}
                    </div>

                    <div className="mt-3 d-grid">
                        <button
                            type="submit"
                            className="btn btn-primary waves-effect waves-light"
                            style={{ backgroundImage: "linear-gradient(90deg, #0ddcef, #319bfc)" }}
                        >
                            Reset Password
                        </button>
                    </div>

                </form>
            )}
        </React.Fragment>
    );
};

export default ResetPassword;
